module.exports = ".ck-content .media{clear:both;margin:1em 0}"